define('home/templates/notificationCardAnnouncement',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return " has-image";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : {};

  return "<span class=\"card-content__media\">\n"
    + ((stack1 = helpers["if"].call(alias1,((stack1 = (depth0 != null ? depth0.announcement : depth0)) != null ? stack1.link : stack1),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "<div style=\"background-image: url("
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.announcement : depth0)) != null ? stack1.image : stack1), depth0))
    + ")\" class=\"img-cards\"></div>\n"
    + ((stack1 = helpers["if"].call(alias1,((stack1 = (depth0 != null ? depth0.announcement : depth0)) != null ? stack1.link : stack1),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "</span>\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "<a href=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.announcement : depth0)) != null ? stack1.link : stack1), depth0))
    + alias2(alias1((depth0 != null ? depth0.linkArgDelimiter : depth0), depth0))
    + "utm_campaign="
    + alias2(alias1((depth0 != null ? depth0.activityId : depth0), depth0))
    + "&utm_content=img&utm_source=note\"\ndata-link-name=\"image\">\n";
},"6":function(container,depth0,helpers,partials,data) {
    return "</a>\n";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "<a href=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.announcement : depth0)) != null ? stack1.link : stack1), depth0))
    + alias2(alias1((depth0 != null ? depth0.linkArgDelimiter : depth0), depth0))
    + "utm_campaign="
    + alias2(alias1((depth0 != null ? depth0.activityId : depth0), depth0))
    + "&utm_content=title&utm_source=note\"\nclass=\"link-gray-darker truncate\"\ndata-truncate-lines=\""
    + alias2(alias1((depth0 != null ? depth0.numTitleLines : depth0), depth0))
    + "\"\ndata-link-name=\"title\">\n";
},"10":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "<p class=\"spacing-narrow spacing-top \">\n<a href=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.announcement : depth0)) != null ? stack1.link : stack1), depth0))
    + alias2(alias1((depth0 != null ? depth0.linkArgDelimiter : depth0), depth0))
    + "utm_campaign="
    + alias2(alias1((depth0 != null ? depth0.activityId : depth0), depth0))
    + "&utm_content=btn&utm_source=note\"\nclass=\"button button-outline text-medium\">\n"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.announcement : depth0)) != null ? stack1.callToAction : stack1), depth0))
    + "\n</a>\n</p>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : {};

  return "<div class=\"card__reason\">\n<div class=\"notification__icon -invite\">\n<span class=\"icon-notification-invite text-brand icon-small\"></span>\n</div>\n"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.announcement : depth0)) != null ? stack1.subject : stack1), depth0))
    + "\n<span class=\"time text-gray\">"
    + alias2(alias1((depth0 != null ? depth0.relativeTime : depth0), depth0))
    + "</span>\n</div>\n<div class=\"card__content -notification"
    + ((stack1 = helpers["if"].call(alias3,((stack1 = (depth0 != null ? depth0.announcement : depth0)) != null ? stack1.image : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\">\n"
    + ((stack1 = helpers["if"].call(alias3,((stack1 = (depth0 != null ? depth0.announcement : depth0)) != null ? stack1.image : stack1),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n<div class=\"card-content__body\">\n<h2 class=\"discussion-title\" dir=\"auto\">\n"
    + ((stack1 = helpers["if"].call(alias3,((stack1 = (depth0 != null ? depth0.announcement : depth0)) != null ? stack1.link : stack1),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.announcement : depth0)) != null ? stack1.title : stack1), depth0))
    + "\n"
    + ((stack1 = helpers["if"].call(alias3,((stack1 = (depth0 != null ? depth0.announcement : depth0)) != null ? stack1.link : stack1),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "</h2>\n\n<div class=\"card-content__summary text-medium\">\n<div class=\"truncate\" data-truncate-lines=\"3\" dir=\"auto\">\n"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.announcement : depth0)) != null ? stack1.body : stack1), depth0))
    + "\n</div>\n</div>\n\n"
    + ((stack1 = helpers["if"].call(alias3,((stack1 = (depth0 != null ? depth0.announcement : depth0)) != null ? stack1.callToAction : stack1),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n</div>\n";
},"useData":true})

});
